// extracted by mini-css-extract-plugin
export default {"credit-bundles-last-updated":"CreditBundles_credit-bundles-last-updated__FgmBs"};